<!--文本-->

<template>
  <div class="attr-text">
    <!-- <div class="text-item flex-b-c">
      <span class="text-attr">名称</span>
      <span>天气</span>
    </div>-->
    <div class="text-item">
      <div class="attr-set-title" style="padding-top: 8px;">{{ $t('PE.Text') }}</div>
      <el-input type="textarea" :rows="2" :placeholder="$t('basics.PleaseInput')"
        v-model="media.ext_val_content"></el-input>
    </div>
    <div class="text-item">
      <div class="attr-set-title">{{ $t('PE.Attribute') }}</div>
      <div class="flex-b-c">
        <el-select v-model="media.ext_val_family" :placeholder="$t('basics.PleaseSelect')" size="mini"
          style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div style="width:130px;">
          <!-- <el-select
            v-model="media.ext_val_textSize"
            filterable
            :filter-method="filterMethod"
            @blur="blur"
            @keyup.enter.native="submit"
            :placeholder="$t('basics.PleaseSelect')"
            size="mini"
            ref="fontSize"
          >
            <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
          </el-select>-->
          <set-font-size @setFontSize="setFontSize" :defaultSize="media.ext_val_textSize"></set-font-size>
        </div>
      </div>
      <div class="font-set flex-b-c">
        <div>
          <img @click="fontSet('ext_val_isBold')" class="font-icon" :class="{ 'select-icon': media.ext_val_isBold }"
            :src="imgRequest('program_text_B.png')" alt />
          <img @click="fontSet('ext_val_isItalic')" class="font-icon" :class="{ 'select-icon': media.ext_val_isItalic }"
            :src="imgRequest('program_text_I.png')" alt />
          <img @click="fontSet('ext_val_underLine')" class="font-icon"
            :class="{ 'select-icon': media.ext_val_underLine }" :src="imgRequest('program_text_U.png')" alt />
        </div>
        <div>
          <img class="font-icon" @click="fontHalign(1)" :class="{ 'select-icon': media.ext_val_halign == 1 }"
            :src="imgRequest('program_text_left.png')" alt />
          <img class="font-icon" @click="fontHalign(4)" :class="{ 'select-icon': media.ext_val_halign == 4 }"
            :src="imgRequest('program_text_center.png')" alt />
          <img class="font-icon" @click="fontHalign(2)" :class="{ 'select-icon': media.ext_val_halign == 2 }"
            :src="imgRequest('program_text_right.png')" alt />
        </div>
      </div>
      <div class="font-set flex-b-c">
        <div>
          <img class="font-icon" @click="fontLine(32)" :class="{ 'select-icon': media.ext_val_valign == 32 }"
            :src="imgRequest('program_text_top.png')" alt />
          <img class="font-icon" @click="fontLine(128)" :class="{ 'select-icon': media.ext_val_valign == 128 }"
            :src="imgRequest('program_text_middle.png')" alt />
          <img class="font-icon" @click="fontLine(64)" :class="{ 'select-icon': media.ext_val_valign == 64 }"
            :src="imgRequest('program_text_bottom.png')" alt />
        </div>
        <div class="font-set-color flex-c-c">
          <el-color-picker class="font-color-picker" v-model="media.ext_val_backgroundColor" @change="bgChange"
            size="mini" :title="$t('PE.BackgroundColor')" :show-alpha="true"
            :predefine="predefineColors"></el-color-picker>
          <el-color-picker class="font-color-picker" v-model="media.ext_val_textColor" size="mini"
            :title="$t('PE.FontColor')" :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        </div>
      </div>
    </div>
    <div class="text-item" v-if="KOMHIDDEN === 0">
      <div class="attr-set-title">{{ $t('PE.PlayTheWay') }}</div>
      <div class="flex-c-c play-m-item">
        <el-radio-group v-model="media.ext_val_scrollDirection" class="flex-b-c">
          <el-radio :label="index" v-show="media.ext_val_scrollDirection == index" v-for="index in 4" :key="index">{{
            $t('PE.Roll') }}</el-radio>
          <el-radio :label="1" v-show="media.ext_val_scrollDirection == 0 || media.ext_val_scrollDirection == 5">{{
            $t('PE.Roll') }}</el-radio>
          <el-radio :label="5">{{ $t('PE.FlipOver') }}</el-radio>
          <el-radio :label="0">{{ $t('PE.Motionless') }}</el-radio>
        </el-radio-group>
      </div>
      <div v-show="media.ext_val_scrollDirection >= 1 && media.ext_val_scrollDirection <= 4" class="play-m">
        <div class="flex-b-c play-m-item">
          <span>{{ $t('PE.RollingDirection') }}</span>
          <el-select v-model="media.ext_val_scrollDirection" :placeholder="$t('basics.PleaseSelect')" size="mini"
            style="width:130px;">
            <el-option v-for="item in directions" :key="item.value" :label="$t(item.label)"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-b-c play-m-item">
          <span>{{ $t('PE.RollingVelocity') }}</span>
          <el-input-number v-model="media.ext_val_scrollSpeed" :min="1" :max="10" :label="$t('PE.Describe')"
            size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>{{ $t('PE.PlayTime') }}(s)</span>
          <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')"
            size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>{{ $t('PE.AttendedMode') }}</span>
          <el-checkbox v-model="media.ext_val_isLoop">{{ $t('PE.EndToEnd') }}</el-checkbox>
        </div>
      </div>
      <div v-show="media.ext_val_scrollDirection === 5" class="flex-b-c play-m-item">
        <span>{{ $t('PE.PlayTime') }}(s)</span>
        <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')"
          size="mini"></el-input-number>
      </div>
      <div class="play-m-item flex-b-c">
        <span class="text-attr">{{ $t('PE.EnterTheAnimation') }}</span>
        <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini"
          style="width:130px;">
          <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="play-m-item flex-b-c">
        <span class="text-attr">{{ $t('PE.TheEntryTime') }}(s)</span>
        <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
      </div>
      <div v-show="media.ext_val_scrollDirection === 0" class="flex-b-c play-m-item">
        <span>{{ $t('PE.PlayTime') }}(s)</span>
        <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')"
          size="mini"></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
import familys from '@static/data/familys.js';
// import fontSize from '@static/data/fontSize.js';
import predefineColors from '@static/data/predefineColors.js';

import SetFontSize from './children/SetFontSize';
import animations from '../../scripts/animations';
const directions = [
  { value: 1, label: "PE.FromLeftToRight" },
  { value: 2, label: "PE.FromRightToLeft" },
  { value: 3, label: "PE.FromTopToBottom" },
  { value: 4, label: "PE.FromTheBottomUp" }
];

export default {
  name: "AttrText",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      familys,
      predefineColors,
      directions,
      sizeVal: 0,
      KOMHIDDEN: 0,
      animations,
    }
  },
  created() {
    this.KOMHIDDEN = parseInt(process.env.VUE_APP_KOM_HIDDEN);
    this.scrollType = this.media.ext_val_scrollDirection
  },
  methods: {
    fontSet(type) {
      this.media[type] = !this.media[type];
    },
    fontHalign(halign) {
      this.media.ext_val_halign = halign;
    },
    fontLine(line) {
      this.media.ext_val_valign = line;
    },
    imgRequest(img) {
      return require("@/assets/images/program/normal/" + img);
    },
    // modeChange(mode) {
    //   console.log(mode);
    //   this.media.ext_val_scrollDirection = parseInt(mode);
    // },
    setFontSize(val) {
      if (typeof (val) === "number") {
        this.media.ext_val_textSize = val;
      }
    },
    // filterMethod(val) {
    //   this.sizeVal = val;
    //   console.log(222222);
    // },
    // blur() {
    //   if (parseInt(this.sizeVal)) {
    //     this.media.ext_val_textSize = parseInt(this.sizeVal);
    //   }
    //   this.$refs.fontSize.blur();
    // },
    // submit() {
    //   if (parseInt(this.sizeVal)) {
    //     this.media.ext_val_textSize = parseInt(this.sizeVal);
    //   }
    //   this.$refs.fontSize.blur();
    // }
    bgChange(rgba) {
      console.log(rgba);
      let RGBAString = rgba;
      let rgbRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(0|(0(\.\d{0,2}))?|1)\)$/;
      let A = RGBAString.match(rgbRegex)[4] * 1;
      if (A === 0) {
        this.media.ext_val_backgroundColor = "rgba(0, 0, 0, 0)";
      } else {
        this.media.ext_val_backgroundColor = rgba;
      }
    }
  },
  components: {
    SetFontSize
  }
}
</script>

<style lang="scss" scoped>
.attr-text {
  padding-right: 4px;

  .text-item {
    .attr-set-title {
      // font-family: "Times New Roman";
      // font-weight: normal;
      // font-stretch: normal;
      // letter-spacing: 3px;
      // color: #617883;
      padding: 16px 0px 8px 4px;
    }

    .play-m-item {
      min-height: 36px;
      margin: 0px 0px 8px 0px;
      color: #617883;
    }

    .font-set {
      padding-top: 6px;

      .font-icon {
        width: 26px;
        margin: 0px 4px;
        border: solid 1px #fff;
        border-radius: 4px;
      }

      .font-icon:hover {
        border: solid 1px #2687fe;
        background-color: #edfbff;
      }

      .select-icon {
        // border: solid 1px #2687fe;
        background-color: #c6e2ff !important;
      }
    }

    .font-set-color {
      width: 114px;

      .font-color-picker {
        margin: 0px 8px;
      }
    }
  }
}
</style>